import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading, trialActive } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF7F2]" data-testid="protected-loading">
        <div className="w-8 h-8 border-2 border-[#0F6B6B] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!trialActive && location.pathname !== "/trial-expired") {
    return <Navigate to="/trial-expired" replace />;
  }
  return children;
}
